import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import useEncryptedURLState from 'hooks/useEncryptedURLState';

export default function useBreadCrumbs() {
  const location = useLocation();

  const [breadCrumbs, setBreadCrumbs] = useEncryptedURLState(
    'breadCrumb',
    location?.state?.breadCrumb ? [{ label: location?.state?.breadCrumb?.label, value: location?.state?.breadCrumb?.value }] : []
  );

  function handleBreadCrumbs(e) {
    setBreadCrumbs((prev) => [
      ...prev,
      {
        label: e.display_name,
        value: e.object_id,
        folder_type: e.folder_type ?? null,
        is_virtual: e.is_virtual ?? null,
        is_system_folder: e.is_system_folder ?? null,
        folder_shared: e.folder_shared === true,
      },
    ]);
  }

  function filterBreadCrumbs(folder_id) {
    let folderIndex = breadCrumbs?.findIndex((item) => item.value === folder_id);
    setBreadCrumbs(breadCrumbs.slice(0, folderIndex + 1));
  }

  return { breadCrumbs, setBreadCrumbs, handleBreadCrumbs, filterBreadCrumbs };
}
